import { Routes } from '@angular/router';

export const remediationsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/remediations-list/remediations-list.component').then(
        (m) => m.RemediationsListComponent
      ),
  },
];
